// importTabs.js
import { Box, Button } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import {
  duplicateColumnDefs,
  duplicateDonorColumnDefs,
  DonorIdMissingColumnDefs,
  DonorFieldMisingColumnDefs,
  prasadErrorColumnDefs,ValidationErrorColumnDefs,
} from "./columnDef";
import { logger } from "../../utils/logger";
import { useSelector } from "react-redux";

export const getImportTabs = ({
  formattedDuplicates,
  duplicateNewDonor,
  DonorFieldsMissing,
  DonorIdMissing,
  formattedPrasadMissing,
  formattedPrasadIncomplete,
  validationErrors, 
  gridRefs,
  gridReadyHandlers,
  exportHandlers,
  user,
}) => [
  {
    label: `Already uploaded donations (${formattedDuplicates.length})`,
    show: formattedDuplicates.length > 0,
    log: () =>
      logger.info("Tab opened: Already uploaded donations", {
        username: user?.username,
        role: user?.role,
      }),
    panel: (
      <>
        <Box sx={{ textAlign: "right" }}>
          <Button
            onClick={exportHandlers.exportDuplicateToExcel}
            variant="contained"
            color="primary"
            startIcon={<DriveFileMoveIcon />}
          >
            Export
          </Button>
        </Box>
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "auto" }}
        >
          <AgGridReact
            ref={gridRefs.duplicateGridRef}
            columnDefs={duplicateColumnDefs}
            rowData={formattedDuplicates}
            domLayout="autoHeight"
            pagination
            paginationPageSize={10}
            paginationPageSizeSelector={[10, 20, 50]}
            onGridReady={gridReadyHandlers.onDuplicateGridReady}
          />
        </div>
      </>
    ),
  },
  {
    label: `Already uploaded donors (${duplicateNewDonor.length})`,
    show: duplicateNewDonor.length > 0,
    log: () =>
      logger.info("Tab opened: Already uploaded donors", {
        username: user?.username,
        role: user?.role,
      }),
    panel: (
      <>
        <Box sx={{ textAlign: "right" }}>
          <Button
            onClick={exportHandlers.exportDuplicateDonorToExcel}
            variant="contained"
            color="primary"
            startIcon={<DriveFileMoveIcon />}
          >
            Export
          </Button>
        </Box>
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "auto" }}
        >
          <AgGridReact
            ref={gridRefs.duplicateDonorGridRef}
            columnDefs={duplicateDonorColumnDefs}
            rowData={duplicateNewDonor}
            columnSize="autoSize"
            domLayout="autoHeight"
            pagination
            paginationPageSize={10}
            paginationPageSizeSelector={[10, 20, 50]}
            onGridReady={gridReadyHandlers.onDuplicateDonorGridReady}
          />
        </div>
      </>
    ),
  },
  {
    label: `Missing Donation Field in New Donors (${DonorFieldsMissing.length})`,
    show: DonorFieldsMissing.length > 0,
    log: () =>
      logger.info("Tab opened: Missing Donation Field", {
        username: user?.username,
        role: user?.role,
      }),
    panel: (
      <>
        <Box sx={{ textAlign: "right" }}>
          <Button
            onClick={exportHandlers.exportDonorMissingFieldToExcel}
            variant="contained"
            color="primary"
            startIcon={<DriveFileMoveIcon />}
          >
            Export
          </Button>
        </Box>
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "auto" }}
        >
          <AgGridReact
            ref={gridRefs.missingFieldGridRef}
            columnDefs={DonorFieldMisingColumnDefs}
            rowData={DonorFieldsMissing}
            domLayout="autoHeight"
            pagination
            paginationPageSize={10}
            paginationPageSizeSelector={[10, 20, 50]}
            onGridReady={gridReadyHandlers.onDonorMissingFieldGridReady}
          />
        </div>
      </>
    ),
  },
  {
    label: `Missing Fields in Existing Donors (${DonorIdMissing.length})`,
    show: DonorIdMissing.length > 0,
    log: () =>
      logger.info("Tab opened: Missing Donor IDs", {
        username: user?.username,
        role: user?.role,
      }),
    panel: (
      <>
        <Box sx={{ textAlign: "right" }}>
          <Button
            onClick={exportHandlers.exportDonorIdMissingToExcel}
            variant="contained"
            color="primary"
            startIcon={<DriveFileMoveIcon />}
          >
            Export
          </Button>
        </Box>
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "auto" }}
        >
          <AgGridReact
            ref={gridRefs.donorIdMissingGridRef}
            columnDefs={DonorIdMissingColumnDefs}
            rowData={DonorIdMissing}
            domLayout="autoHeight"
            pagination
            paginationPageSize={10}
            paginationPageSizeSelector={[10, 20, 50]}
            onGridReady={gridReadyHandlers.onDonorIdMissingGridReady}
          />
        </div>
      </>
    ),
  },
  {
    label: `Prasad Yes - Missing Donors (${formattedPrasadMissing.length})`,
    show: formattedPrasadMissing.length > 0,
    log: () =>
      logger.info("Tab opened: Prasad Yes - Missing Donors", {
        username: user?.username,
        role: user?.role,
      }),
    panel: (
      <>
        <Box sx={{ textAlign: "right" }}>
          <Button
            onClick={exportHandlers.exportPrasadMissingToExcel}
            variant="contained"
            color="primary"
            startIcon={<DriveFileMoveIcon />}
          >
            Export
          </Button>
        </Box>
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "auto" }}
        >
          <AgGridReact
            ref={gridRefs.prasadMissingGridRef}
            columnDefs={prasadErrorColumnDefs}
            rowData={formattedPrasadMissing}
            domLayout="autoHeight"
            pagination
            paginationPageSize={10}
            paginationPageSizeSelector={[10, 20, 50]}
            onGridReady={gridReadyHandlers.onPrasadMissingGridReady}
          />
        </div>
      </>
    ),
  },
  {
    label: `Prasad Yes - Incomplete Donors (${formattedPrasadIncomplete.length})`,
    show: formattedPrasadIncomplete.length > 0,
    log: () =>
      logger.info("Tab opened: Prasad Yes - Incomplete Donors", {
        username: user?.username,
        role: user?.role,
      }),
    panel: (
      <>
        <Box sx={{ textAlign: "right" }}>
          <Button
            onClick={exportHandlers.exportPrasadIncompleteToExcel}
            variant="contained"
            color="primary"
            startIcon={<DriveFileMoveIcon />}
          >
            Export
          </Button>
        </Box>
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "auto" }}
        >
          <AgGridReact
            ref={gridRefs.prasadIncompleteGridRef}
            columnDefs={prasadErrorColumnDefs}
            rowData={formattedPrasadIncomplete}
            domLayout="autoHeight"
            pagination
            paginationPageSize={10}
            paginationPageSizeSelector={[10, 20, 50]}
            onGridReady={gridReadyHandlers.onPrasadIncompleteGridReady}
          />
        </div>
      </>
    ),
  },
  {
  label: `Book/Receipt Mismatch (${validationErrors.length})`,
  show: validationErrors.length > 0,
  log: () =>
    logger.info("Tab opened: Book/Receipt Mismatch", {
      username: user?.username,
      role: user?.role,
    }),
  panel: (
    <>
      <Box sx={{ textAlign: "right" }}>
        <Button
          onClick={exportHandlers.exportValidationErrorToExcel}
          variant="contained"
          color="primary"
          startIcon={<DriveFileMoveIcon />}
        >
          Export
        </Button>
      </Box>
      <div className="ag-theme-alpine" style={{ width: "100%", height: "auto" }}>
        <AgGridReact
          ref={gridRefs.validationErrorGridRef}
          columnDefs={ValidationErrorColumnDefs}
          rowData={validationErrors}
          domLayout="autoHeight"
          pagination
          paginationPageSize={10}
          paginationPageSizeSelector={[10, 20, 50]}
          onGridReady={gridReadyHandlers.onValidationErrorGridReady}
          // defaultColDef={defaultColDef}
          // loadingOverlayComponent={AgGridLoader}
          loadingOverlayComponentParams={{ loadingMessage: "Loading data, please wait..." }}
        />
      </div>
    </>
  ),
},
  
];
